import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../container/context";
import api from "../../../services/api";
import Form from "../../../components/form";
import ActionTable from "../../../components/table/ActionTable";

export default function EscolasExclusividade({ produtoId }) {
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [escolasExclusividade, setEscolasExclusividade] = useState([]);

  useEffect(() => {
    listarEscolas();
  }, []);

  const carregarComboEscolas = (escolas) => {
    api
      .get("escolas/listar", { ativas: true })
      .then((res) => {
        const comboEscolas = res.filter(
          (e) =>
            escolasExclusividade.filter((ee) => ee.escolaId === e.id).length ===
            0
        );

        setComboEscolas(res);
      })
      .catch((err) => notification("error", "Erro ao listar as escolas"));
  };

  const listarEscolas = () => {
    api
      .get("produtos/escolasExclusividade", {
        produtoId: produtoId,
      })
      .then((escolasExclusividade) => {
        setEscolasExclusividade(escolasExclusividade);
        carregarComboEscolas(escolasExclusividade);
      })
      .catch(() =>
        notification("error", "Erro ao listar as escolas com venda exclusiva.")
      );
  };

  const camposInclusaoEscola = () => {
    return {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        // value: produto.categoriaId,
        // space: 6,
      },
    };
  };

  const inserirEscolaExclusividade = (form) => {
    api
      .put("produtos/inserirEscolaExclusividade", {
        produtoId: produtoId,
        escolaId: form.escolaId,
      })
      .then(() => {
        notification("success", "Exclusividade salva para a escola.");
        listarEscolas();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao inserir a exclusividade.");
      });
  };

  const removerEscolaExclusividade = (escolaId) => {
    api
      .delete("produtos/removerEscolaExclusividade", {
        produtoId: produtoId,
        escolaId,
      })
      .then(() => {
        notification("warning", "Exclusividade removida para a escola.");
        listarEscolas();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao inserir a exclusividade.");
      });
  };

  const fInclusaoEscola = {
    title: "Inserir escola",
    form: camposInclusaoEscola(),
    submit: {
      label: "Adicionar",
      action: inserirEscolaExclusividade,
    },
  };

  const tEscolasExclusividade = {
    title: "Escolas com venda exclusiva",
    key: "escolaId",
    array: escolasExclusividade,
    columns: [
      {
        name: "escolaNomeFantasia",
        label: "Escola",
      },
    ],
    actions: [
      {
        name: "delete",
        icon: "zmdi zmdi-delete",
        action: removerEscolaExclusividade,
      },
    ],
  };

  return (
    <div>
      <h2>Escolas (Venda exclusiva)</h2>
      <Form formData={fInclusaoEscola} />

      {escolasExclusividade.length > 0 ? (
        <ActionTable structure={tEscolasExclusividade} />
      ) : (
        <h3>Produto sem venda exclusiva.</h3>
      )}
    </div>
  );
}
